const _ = require('lodash'), angular = require('angular');
const mergeInspirationFeatureCards = require('../inspiration/merge-inspiration-cards');
const CardListCtrl = require('./card-list-controller');
const atmProductClickMapper = require('./atm/product-click-mapper');
const linkClickMapper = require('./atm/link-click-mapper');
const atmInternalCampaignMapper = require('../../../common/components/analytics/atm-mapper-internal-campaign');

module.exports = function ($timeout, $location, $q, settingsService, cardDetailService, movefocus, breakpointsService, inspirationService, $compile, shopPageStateService, settingsByBreakpoint, cardSizeService, $state, pageMetadataService, FiltersService, ProgressivePagingService, CacheService, CategoriesService, searchService, $window, atm, $rootScope) {

    return {
        restrict: 'E',
        transclude: true,
        scope: {
            className: '@',
            pageName: '=?',
            showHeader: '&?'
        },
        require: ['?^wowPanels'],
        controller: ['$scope', '$sce', '$q', '$state', 'BreakpointsService', 'CardDetailService', 'CardSizeService', 'CardSortService', 'SettingsService', CardListCtrl],
        compile() {
            return {
                pre(scope, element, controllers) {
                    scope.cardSizes = cardSizeService.sizes;
                    scope.totalRecordCount = 0;
                    scope.isInfiniteScrollingEnabled = true;
                    scope.canLoadMore = true;
                    scope.filtersService = FiltersService;
                    scope.hideOutOfStockItems = scope.pageName === 'plp' || scope.pageName === 'product group'
                        ? scope.filtersService.getHideOutOfStockPreference()
                        : false;
                    scope.pageLoading = false;
                    scope.isLoading = false;
                    scope.isInitializing = true;
                    scope.showLoadPrevious = false;

                    const wowPanels = controllers[0];
                    let isZeroCardsTemplateCompiled = false;

                    function showLoadingSpinner() {
                        scope.loadingTimeout = $timeout(() => {
                            scope.isLoading = true;
                        }, 500);
                    }

                    function hideLoadingSpinner() {
                        if (scope.loadingTimeout) {
                            $timeout.cancel(scope.loadingTimeout);
                            scope.loadingTimeout = null;
                        }
                        // force digest
                        $timeout(() => {
                            scope.isLoading = false;
                        }, 0, true);
                    }

                    function compileZeroCardsTemplate() {
                        if (scope.zeroCardsTemplate) {
                            const angularElement = angular.element(scope.zeroCardsTemplate);
                            element.find('._card-list-zero-results').html(angularElement);
                            $compile(angularElement)(scope.$new(true));

                            isZeroCardsTemplateCompiled = true;
                        }
                    }

                    function pageSizeSetting() {
                        return settingsByBreakpoint.getSettingValueByBreakpoint('OneSite', {
                            largeFormat: 'LargeFormatPageSize',
                            mediumFormat: 'MediumFormatPageSize',
                            smallFormat: 'SmallFormatPageSize'
                        });
                    }

                    function goToPageOne(pushAtm) {
                        $rootScope.$broadcast('cardlist:loading');
                        CacheService.clearCache();
                        scope.pageNumber = 1;
                        scope.hideOutOfStockItems = scope.pageName === 'plp' || scope.pageName === 'product group'
                            ? scope.filtersService.getHideOutOfStockPreference()
                            : false;
                        const sn = $state.current.name;
                        const sp = $state.params;
                        delete sp.pageNumber;
                        $state.go(sn, sp, { notify: false, inherit: false })
                            .then(() => scope.update(true))
                            .then(() => { if (pushAtm) $timeout(pageMetadataService.pushAtm); });
                    }

                    scope.loadPreviousClick = function () {
                        goToPageOne(true);
                        scope.showLoadPrevious = false;
                    };

                    scope.showZeroCardsTemplate = function () {
                        const shallShow = scope.cards && scope.cards.length === 0 && !scope.isLoading && !scope.pageLoading && !scope.isInitializing && !searchService.isRedirecting;

                        if (shallShow && !isZeroCardsTemplateCompiled) {
                            compileZeroCardsTemplate();
                        }

                        return shallShow;
                    };

                    scope.resetCards = function () {
                        scope.cards = [];
                        scope.availableCards = [];
                        scope.totalRecordCount = 0;
                        scope.canLoadMore = false;

                        if (scope.resetScroll) {
                            shopPageStateService.resetCenterPanelScroll();
                        }

                        if (wowPanels) {
                            wowPanels.setFooterVisibility(!scope.canLoadMore || scope.showZeroCardsTemplate());
                        }
                    };

                    // Handlers
                    scope.showHeaderClasses = function () {
                        return scope.showHeader && scope.showHeader()
                            ? 'cardList-header hidden-xs'
                            : 'sr-only cardList-header-placeholder';
                    };

                    scope.update = function getCards(shouldGetFirstPage) {
                        const pageNumberPattern = /pageNumber\=(\d+)/gi;
                        let currentUrl = $state.href($state.current.name, $state.params, { absolute: true });
                        let cached = null;
                        let totalCount = 0;
                        let totalLoaded = 0;

                        // reset default
                        if (shouldGetFirstPage) {
                            scope.pageLoading = true;
                            scope.pageNumber = 1;
                            scope.totalRecordCount = 0;
                            scope.pageSize = pageSizeSetting();
                            scope.title = scope.getTitle();

                            settingsService.invalidateAdsStockCodes();
                        } else {
                            showLoadingSpinner();
                        }

                        if (!pageNumberPattern.test(currentUrl)) {
                            const delimiter = currentUrl.indexOf('?') !== -1 ? '&' : '?';
                            currentUrl += delimiter + 'pageNumber=' + scope.pageNumber;
                        }

                        currentUrl = currentUrl.replace(pageNumberPattern, 'pageNumber=' + scope.pageNumber);

                        if (shouldGetFirstPage && $state.params.pageNumber) {
                            scope.pageNumber = parseInt($state.params.pageNumber);
                            currentUrl = currentUrl.replace(pageNumberPattern, 'pageNumber=' + scope.pageNumber);

                            scope.showLoadPrevious = true;
                        }

                        cached = CacheService.pop(currentUrl);

                        // Get the stuff
                        return $q.all({
                            sorting: scope.sortingReady,
                            pageSize: scope.pageSize,
                            paginationEnabled: false,
                            infiniteScrollEnabled: true,
                            banner: true,
                            filter: scope.filtersService.getAppliedFilters()
                        })
                            // Get the cards
                            .then(function (result) {
                                const isSpecial = null;

                                scope.pageSize = result.pageSize;

                                if (shouldGetFirstPage) {
                                    if (scope.resetScroll && !breakpointsService.isInSmallFormat) {
                                        shopPageStateService.resetCenterPanelScroll();
                                    }

                                    scope.cards = [];
                                    scope.usePagingControl = result.paginationEnabled && !result.infiniteScrollEnabled && !scope.disablePaging;
                                }

                                if (cached == null) {
                                    const cardsPromise = scope.getCards(result.pageSize, scope.pageNumber, isSpecial, result.filter, result.banner);

                                    return scope.pageNumber === 1 && scope.shouldGetInspirationCards
                                        ? $q.all({
                                            cards: cardsPromise,
                                            inspirationCards: inspirationService.getCardsForUrl($location.pathAndSearch())
                                        })
                                        : $q.all({
                                            cards: cardsPromise
                                        });
                                }

                                return cached;
                            })
                            .then(function (result) {

                                if (cached == null && result && result.cards) {
                                    // Get the inspiration cards for the 'current page'
                                    const cards = result.cards.items;

                                    totalCount = result.cards.totalRecordCount;
                                    totalLoaded = cards.length <= scope.pageSize
                                        ? scope.pageSize * (scope.pageNumber - 1) + cards.length
                                        : cards.length;

                                    scope.productCollection = result.cards.productCollection;
                                    scope.totalRecordCount = totalCount;
                                    scope.maxPageNumber = Math.ceil(totalCount / scope.pageSize);
                                    scope.canLoadMore = scope.pageNumber < scope.maxPageNumber;

                                    if (scope.maxPageNumber > 0 && scope.pageNumber > scope.maxPageNumber) {
                                        return;
                                    }

                                    if (scope.maxPageNumber === scope.pageNumber) {
                                        totalLoaded = totalCount;
                                    }

                                    mergeInspirationFeatureCards(cards, inspirationService.inspirationCards, scope.pageNumber, scope.pageSize, scope.totalRecordCount, result.cards.featureTiles);

                                    let newCardsStartingPosition = scope.usePagingControl
                                        ? 0
                                        : _.filter(scope.cards, { isDetail: false }).length;

                                    // Put the cards into scope
                                    _.forEach(cards, function (card) {
                                        card.position = newCardsStartingPosition;
                                        card.isDetail = false;
                                        newCardsStartingPosition++;
                                    });

                                    scope.cards = scope.usePagingControl
                                        ? cards
                                        : scope.cards.concat(cards);

                                    if (wowPanels) {
                                        wowPanels.setFooterVisibility(!scope.canLoadMore || scope.showZeroCardsTemplate());
                                    }

                                    //determine the banner position
                                    const url = $state.href($state.current.name, $state.params, { absolute: true });
                                    const objectBanners = CacheService.getBannerCache(url);

                                    if (objectBanners) {
                                        _.forEach(objectBanners, function (banner, key) {
                                            banner[0].IndexPosition = scope.getSlimBannerOffSetPosition(Number(key));
                                        });
                                        scope.sponsoredSlimBanners = objectBanners;
                                    }
                                    return;
                                }

                                scope.cards = cached ? cached.cards : null;

                            }).finally(function () {

                                if (scope.maxPageNumber > 0 && scope.pageNumber > scope.maxPageNumber) {
                                    if (!navigator.userAgent || navigator.userAgent.indexOf('Prerender') === -1) {
                                        $timeout(goToPageOne);
                                    } else {
                                        let locationURL = '';
                                        if (($location.absUrl().toLowerCase().indexOf('productgroup') !== -1 ||
                                            $location.absUrl().toLowerCase().indexOf('search') !== -1) && $state.params.filters) {
                                            locationURL = pageMetadataService.getNormalizedCanonicalUrl();
                                        } else {
                                            const url = $location.absUrl();
                                            let baseUrl = url.indexOf('?') === -1 ? url : url.split('?')[0];
                                            const params = url.indexOf('?') === -1 ? '' : url.split('?')[1];
                                            let filters = '';
                                            if (params) {
                                                filters = params.indexOf('filters') === -1 ? '' : params.split('filters')[1];
                                                if (filters) {
                                                    filters = filters.indexOf('&') === -1 ? filters : filters.split('&')[0];
                                                    baseUrl = baseUrl + '?filters' + filters;
                                                }
                                            }
                                            locationURL = baseUrl;
                                        }
                                        $state.$current.data.prerender = {
                                            name: 'prerender-status-code',
                                            value: '301',
                                            location: locationURL
                                        };
                                    }
                                    return;
                                }

                                if (shouldGetFirstPage && $state.params.pageNumber && scope.pageNumber > 1 && cached) {
                                    scope.showLoadPrevious &= cached.cards.length <= (scope.pageNumber - 1) * scope.pageSize;
                                }

                                const cacheObj = cached ||
                                {
                                    cards: scope.cards,
                                    totalLoaded,
                                    totalCount,
                                    scope: {
                                        pageNumber: scope.pageNumber,
                                        canLoadMore: scope.canLoadMore,
                                        productCollection: scope.productCollection,
                                        totalRecordCount: scope.totalRecordCount,
                                        maxPageNumber: scope.maxPageNumber
                                    },

                                    filters: scope.filtersService.filters,
                                    sponsoredSlimBanners: { banners: scope.sponsoredSlimBanners },
                                };

                                CategoriesService.categories = cacheObj.categories;
                                scope.pageNumber = cacheObj.scope.pageNumber;
                                scope.canLoadMore = cacheObj.scope.canLoadMore;
                                scope.productCollection = cacheObj.scope.productCollection;
                                scope.totalRecordCount = cacheObj.scope.totalRecordCount;
                                scope.maxPageNumber = cacheObj.scope.maxPageNumber;
                                scope.filtersService.filters = cacheObj.filters;
                                scope.filtersService.resultCount = cacheObj.totalCount;
                                totalLoaded = cacheObj.totalLoaded;
                                totalCount = cacheObj.totalCount;
                                scope.sponsoredSlimBanners = cacheObj.sponsoredSlimBanners.banners;

                                if (!scope.disablePaging) {
                                    pageMetadataService.controlSeries(scope.pageNumber, scope.maxPageNumber);
                                }

                                ProgressivePagingService.updateProgress(totalLoaded, totalCount);

                                if (cacheObj.totalCount > 0) {
                                    CacheService.set(currentUrl, cacheObj);
                                }

                                scope.currentUrl = currentUrl;
                                scope.currentStateName = $state.current.name;

                                if (cached && $window.RR.jsonCallback && cached.RRdata) {
                                    $window.RR.data.JSON = cached.RRdata;
                                    $window.RR.jsonCallback();
                                }

                                hideLoadingSpinner();
                                scope.pageLoading = false;
                                scope.isInitializing = false;
                                $rootScope.$broadcast('cardlist:loaded');
                                const unavailableCount = scope.cards.filter(x => x.data && x.data.product && !x.data.product.IsAvailable).length || 0;
                                scope.filtersService.unavailableCount = unavailableCount;
                            });
                    };

                    const rePositionCardsAfterDelete = function () {
                        let cardsLength = 0;

                        // Recalculate position for the cards in the scope
                        _.forEach(scope.cards, function (card) {
                            if (!card.isDetail) {
                                // we add 10 between cards so we can add card detail between card
                                card.position = cardsLength;
                                cardsLength++;
                            }
                        });
                    };

                    scope.setStampSize = function (size) {
                        if (size === scope.stampSize) {
                            return;
                        }

                        cardSizeService.setSize(size);
                        scope.closeStaticDetails();
                    };

                    // delete the old selected Product Detail from the products
                    function removeCardDetail() {
                        for (let k = 0; k < scope.cards.length; k++) {
                            if (scope.cards[k].isDetail) {
                                scope.cards.splice(k, 1);
                                scope.cardDetail.position = 0;
                            }
                        }
                    }

                    scope.loadMoreCards = function ($event) {
                        if ($event) {
                            $event.preventDefault();
                        }

                        if (!scope.canLoadMore) {
                            const defer = $q.defer();
                            defer.resolve([]);
                            return defer.promise;
                        }
                        // We take note of how many cards are in the list before
                        // updating so we can focus on the first new card. We can't use page size to do this
                        // because we are not guaranteed to always get <page size> number of cards from the server.
                        scope.pageNumber++;
                        return scope.update(false)
                            .then(() =>
                                $state.go('.', { pageNumber: scope.pageNumber }, { notify: false })
                                    .then(() => $timeout(pageMetadataService.pushAtm))
                            );
                    };

                    scope.pageSelected = function (pageNumber) {
                        scope.pageNumber = pageNumber;
                        scope.closeStaticDetails();
                        return scope.update(false).then(function () {
                            // Scroll center panel to top whenever the page is selected
                            shopPageStateService.resetCenterPanelScroll();

                            return movefocus('._card:eq(0)');
                        });
                    };

                    // get the card detail position
                    // the card will be after the last item on the row where the selected card is
                    function getCardDetailPosition() {
                        if (breakpointsService.isInSmallFormat) {
                            if (typeof cardDetailService.cardIndex === 'undefined') {
                                return 0;
                            }
                            // if small format then the position of the card detail is just after the opened card, the card per row is set to 1
                            cardDetailService.cardPerRow = 1;
                            return cardDetailService.cardIndex + 1;
                        }
                        const itemPerRow = Math.round(element.find('.cardList-cards').width() / element.find('.card:not(.ng-hide)').width());
                        cardDetailService.cardPerRow = itemPerRow;
                        if (typeof cardDetailService.cardIndex === 'undefined') {
                            return 0;
                        }
                        return Math.ceil((cardDetailService.cardIndex + 1) / itemPerRow) * itemPerRow;
                    }

                    function addDetail(newPosition) {
                        if (cardDetailService.openCard && 'detail' in cardDetailService.openCard && scope.cardDetail !== cardDetailService.openCard.detail) {
                            // reset the productDetail object
                            scope.cardDetail = cardDetailService.openCard.detail;

                            scope.cardDetail.position = newPosition;
                            scope.cardDetail.isDetail = true;

                            // add the detail object in the list
                            scope.cards.splice(scope.cardDetail.position, 0, scope.cardDetail);
                        } else if (!cardDetailService.openCard) {
                            // a card isn't open, make sure to clear previously set scope.cardDetail
                            scope.cardDetail = undefined;
                        }
                    }

                    scope.closeStaticDetails = function () {
                        cardDetailService.closeCardDetail();
                        scope.showStaticProductDetails = false;
                        scope.showStaticRecipeDetails = false;
                    };

                    let updateCallCounter = 0;

                    scope.updateDetail = function () {
                        // If we have productId in the state params we need to ignore the first two updates so they don't close the static details
                        if (updateCallCounter < 1 && (scope.showStaticProductDetails || scope.showStaticRecipeDetails)) {
                            updateCallCounter++;
                            return;
                        }

                        scope.showStaticProductDetails = false;
                        scope.showStaticRecipeDetails = false;

                        removeCardDetail();

                        // add the new card Detail
                        $timeout(function () {
                            addDetail(getCardDetailPosition());
                        });
                    };

                    scope.$on('login:success', function (e, loginResult, loginPrompt) {
                        if (!loginPrompt.willRedirect && scope.updateCardsOnLogin) {
                            shopPageStateService.resetCenterPanelScroll();
                            CacheService.clearCache();
                            scope.update(true);
                        }
                    });

                    scope.$on('filter:applied', function () {
                        goToPageOne();
                    });

                    scope.$on('filter:toggleOOS', function() {
                        const currentUrl = $location.url();
                        let pageType = '';
                        if (currentUrl.startsWith('/productgroup')) {
                            pageType = 'product group';
                        } else if (currentUrl.startsWith('/search')) {
                            pageType = 'search';
                        } else if (currentUrl.includes('/brand/')) {
                            pageType = 'brand';
                        } else {
                            pageType = 'plp';
                        }
                        if (scope.pageName === 'plp' || scope.pageName === 'product group') {
                            scope.hideOutOfStockItems = scope.filtersService.getHideOutOfStockPreference();
                        } else {
                            scope.hideOutOfStockItems = false;
                        }
                        atm.push({
                            linkType: 'out of stock toggle',
                            linkName: `web:${pageType}:${scope.hideOutOfStockItems ? 'hide' : 'show'} out of stock`
                         }, linkClickMapper);
                    });

                    scope.$on('store:updated', function (event, args) {
                        if (args.isFirstLoad) return;

                        goToPageOne();
                    });

                    scope.$on('RR:completed', function () {
                        if (scope.currentUrl) {
                            const cache = CacheService.get(scope.currentUrl);
                            if (cache && scope.currentStateName === $state.current.name) {
                                cache.RRdata = $window.RR.data.JSON;
                            }
                        }
                    });

                    scope.cards = [];
                    scope.breakpointsService = breakpointsService;

                    scope.loadMoreUrl = function () {
                        let pageNumber = scope.pageNumber;
                        if (scope.canLoadMore) {
                            pageNumber++;
                        }

                        return $state.href($state.$current.self.name, { pageNumber });
                    };

                    scope.reportSlimBannerClicks = function (slimBanner, rowPosition, index) {
                        searchService.slimBannerClick(slimBanner.ClickTracker);
                        const slimBannerIndexPosition = slimBanner.IndexPosition + 1 + index;

                        triggerAnalyticsTracking(slimBannerIndexPosition, slimBanner, 'slim banner', rowPosition + 1);
                    };

                    scope.updateProductClickMapper = function (card) {
                        // Sponsored and Organic Products
                        if (card && card.data && card.data.product && card.data.product.Stockcode) {
                            const searchQueryParams = $location.search();
                            const atmData = {
                                productRank: card.position + 1,
                                productSKU: card.data.product.Stockcode,
                                searchTerm: searchQueryParams.searchTerm || card.data.product.searchTerm || '',
                                isSponsored: card.data.product.IsSponsored,
                                promoteIQCampaignId: card.data.product.CampaignId,
                            };

                            atm.push(atmData, atmProductClickMapper);
                        }
                        // Sponsored Feature Tiles
                        if (card && card.data && card.data.contentCard && card.data.contentCard.CampaignId && card.data.contentCard.ImpressionTracker) {
                            const rowPosition = getFeatureTileRowPosition(card, scope);
                            const countChange = countForSlimBannerPositionChange(card, scope);
                            triggerAnalyticsTracking(card.position + countChange, card.data.contentCard, 'feature tile', rowPosition);
                        }
                    };

                    function getFeatureTileRowPosition(card, scope) {
                        const allCards = scope.cards;
                        const screenWidth = window.innerWidth;
                        const itemsPerRow = screenWidth >= 1200 ? 5 : screenWidth >= 992 ? 4 : screenWidth >= 768 ? 3 : 2;

                        let currentRow = 0;
                        let columnIndex = 0;

                        for (var i = 0; i <= card.position; i++) {
                            const isInspirationBanner = allCards[i] && allCards[i].data && allCards[i].data.contentCard && allCards[i].data.contentCard.ImageType === 'Html' && isFullWithBanner(allCards[i].data.contentCard.ContentHtml);
                            const enableFeedbackBanner = (i === scope.vocPos) && !scope.disableVoc;
                            const enableFootyPageBanner = (i === scope.FootyPageVocPos) && (scope.isFootyPage || scope.isMothersDayPage || scope.isMothersDayPage || scope.isWinterWarmerPage);


                            if (isInspirationBanner) {

                                currentRow += 1;
                                columnIndex = 0;
                                continue;
                            }

                            if (columnIndex === 0) {
                                currentRow += 1;
                            }


                            if ((columnIndex + 1) % itemsPerRow === 0) {
                                columnIndex = 0;
                            } else {
                                if (enableFeedbackBanner || enableFootyPageBanner) {
                                    currentRow += 1;
                                }
                                columnIndex += 1;
                            }

                        }

                        let index = 0
                        _.forEach(scope.sponsoredSlimBanners, function (_, key) {
                            if (currentRow - index > Number(key)) {
                                currentRow += 1;
                                index++;
                            }
                        });

                        return currentRow;
                    }

                    function triggerAnalyticsTracking(index, sponsored, type, rowPosition) {
                        const searchQueryParams = $location.search();
                        atm.push({
                            type: 'promote iq sponsored ' + type,
                            place: rowPosition,
                            position: index + 1,
                            promoteIQCampaignId: sponsored.CampaignId,
                            linkName: (searchQueryParams.searchTerm || sponsored.searchTerm) ? 'web:search:product click:sponsored ' + type + ' click' : 'web:browse:product click:sponsored ' + type + ' click',
                            linkType: type + ' click from listing pages'
                        }, atmInternalCampaignMapper);
                    }

                    function countForSlimBannerPositionChange(card, scope) {
                        const slimBanners = Object.entries(scope.sponsoredSlimBanners || []).map(item => ({ [item[0]]: item[1] }));
                        const slimBannersArray = slimBanners.map(function (item) {
                            return angular.extend(Object.values(item)[0][0],
                                { slimBannerCardPosition: scope.getSlimBannerOffSetPosition(Number(Object.keys(item)[0])) });
                        }
                        );

                        const count = slimBannersArray.reduce((accumulator, slimBanner) => {
                            if (slimBanner.Sponsored && card && card.position > slimBanner.slimBannerCardPosition) {
                                return accumulator + 1;
                            } else {
                                return accumulator;
                            }
                        }, 0);

                        return count;
                    }

                    function isFullWithBanner(html) {
                        return html.includes(".card-list-item--full-width");
                    }

                    scope.getSlimBannerOffSetPosition = function (slimBannerRowPosition) {
                        const allCards = scope.cards;
                        const screenWidth = window.innerWidth;
                        const itemsPerRow = screenWidth >= 1200 ? 5 : screenWidth >= 992 ? 4 : screenWidth >= 768 ? 3 : 2;
                        const totalIndex = slimBannerRowPosition * itemsPerRow - 1;
                        let currentRow = 0;
                        let columnIndex = 0;

                        for (let i = 0; i <= totalIndex; i++) {
                            const isInspirationBanner = allCards[i] && allCards[i].data && allCards[i].data.contentCard && allCards[i].data.contentCard.ImageType === 'Html' && isFullWithBanner(allCards[i].data.contentCard.ContentHtml);
                            const enableFeedbackBanner = (i === scope.vocPos) && !scope.disableVoc;
                            const enableFootyPageBanner = (i === scope.FootyPageVocPos) && (scope.isFootyPage || scope.isMothersDayPage || scope.isMothersDayPage || scope.isWinterWarmerPage);

                            if ((columnIndex + 1) % itemsPerRow === 0) {
                                currentRow += 1;
                                columnIndex = 0;

                                if (isInspirationBanner) {
                                    currentRow += 1;
                                }

                            } else {

                                if (isInspirationBanner) {
                                    currentRow += 1 + (columnIndex > 0 ? 1 : 0);
                                } else {
                                    if (enableFeedbackBanner || enableFootyPageBanner) {
                                        currentRow += 1;
                                    }
                                    columnIndex += 1;
                                }
                            }

                            if (isInspirationBanner) {
                                columnIndex = 0;
                            }

                            if (currentRow >= slimBannerRowPosition) {
                                return (isInspirationBanner && currentRow > slimBannerRowPosition) ? i - 1 : i;
                            }
                        }

                        return 0;

                    };

                    scope.parseIndexPosition = function (key, index) {
                        return parseInt(key) + index;
                    };

                    scope.$watch(function () {
                        return cardSizeService.currentSize;
                    }, function (newVal, oldVal) {
                        if (newVal !== oldVal) {
                            scope.stampSize = newVal;
                        }
                    });

                    scope.$watch('pageLoading', function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            scope.$emit('cardList:isPageLoading', scope.pageLoading);
                        }
                    });

                    scope.$watch('cards', function (cards) {
                        scope.availableCards = cards && cards.length
                        ? cards.filter(x => x.data && (x.data.contentCard || x.data.product && x.data.product.IsAvailable))
                        : [];
                    });

                    if ($state.current.name === 'shop.watchlist') {
                        scope.$on('savedList:remove', function (events, args) {
                            scope.cards = _.filter(scope.cards, function (card) { return (card.data.product !== undefined && card.data.product.Stockcode !== args); });
                            rePositionCardsAfterDelete();
                        });
                    }

                    scope.$on('$destroy', function () {
                        inspirationService.inspirationCards = null;
                    });
                    scope.vocPos = (window.innerWidth >= 1200 || window.innerWidth < 768) ? 9 : window.innerWidth >= 992 ? 7 : 8;
                    scope.FootyPageVocPos = scope.breakpointsService.isInSmallFormat ? 7 : 9;
                    scope.disableVoc = $state.current.name === 'shop.productgroup' ? true : false;
                    scope.isFootyPage = $state.params.Id && $state.params.Id === 'sports-specials' ? true : false;
                    scope.isMothersDayPage = $state.params.Id && $state.params.Id.toLowerCase().includes('mothers') ? true : false;
                    scope.isWinterWarmerPage = $state.params.Id && $state.params.Id.toLowerCase().includes('winter-warmers') ? true : false;
                }
            };
        },
        template: require('./card-list-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/card-list-directive.js
 **/